import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { BoardFilters, Button, Placeholder, RemoteSunburst, TsDataSource } from "../index";
import { useState } from "react";
import { deepCopy } from "../general/utils";
import { upsertComponentConfig } from "../boards/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import SliceByDrawer from "./SliceByDrawer";
function BoardSunburst(props) {
    const { id, objectType, size } = props;
    const ds = new TsDataSource();
    const [config, setConfig] = useState(props.config);
    const [openFilters, setOpenFilters] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const onModalSave = (updatedConfig) => {
        setConfig({ ...updatedConfig });
        upsertComponentConfig(ds, id, { ...updatedConfig });
        setForceUpdate(!forceUpdate);
    };
    const configButtons = [
        _jsxs("div", { children: [_jsx(Button, { outline: true, position: "right", type: "primary", onClick: () => setOpenConfig(true), icon: "sliders", className: "count-filter-button" }), _jsx(Button, { outline: true, position: "right", type: "primary", onClick: () => setOpenFilters(true), icon: "filter", className: "count-filter-button" })] }, "board-sunburst-config"),
    ];
    return (_jsxs("div", { style: { height: "100%" }, children: [_jsx(BoardFilters, { endpoint: objectType, entityType: "component", open: openFilters, setOpen: setOpenFilters, ...props }), _jsx(SliceByDrawer, { ...props, sliceBy: config.sliceBy || [], endpoint: objectType, open: openConfig, setOpen: setOpenConfig, onConfigSave: onModalSave, title: "Sunburst Configuration" }), config.sliceBy && config.sliceBy.length > 0 ?
                _jsx("div", { style: { height: '100%' }, children: _jsx(RemoteSunburst, { id: id, sliceBy: deepCopy(config.sliceBy), title: props.title, endpoint: objectType, baseUrl: props.baseUrl, zone: props.zone, setZone: props.setZone, forceUpdate: forceUpdate, legendPosition: "top", noMini: size === "sm", buttons: configButtons }) })
                :
                    _jsxs("div", { className: "tol-table", style: { height: '100%' }, children: [_jsx("div", { children: configButtons }), _jsx("div", { style: { height: '100%', marginTop: '6px' }, children: _jsx(Placeholder, { pie: true, height: '100%', message: _jsxs(_Fragment, { children: ["Please add an attribute to get started. Click", _jsx(FontAwesomeIcon, { icon: faSliders, size: "lg", style: { padding: "0 10" } }), "to configure."] }) }) })] })] }));
}
export default BoardSunburst;
